import React, {useState, useEffect, useRef} from 'react';
import Select from 'react-select';
import DropdownReportOption from '../../../container/dropdown/dropdown-report-create/DropdownReportOption';
import DateRangePickerWithCalendar from '../../calendar/DateRangePickerWithCalendar';
import SubQueryOption from '../report-create-page/SubQueryOption';
import CheckboxImg from '../../checkbox/CheckboxImg';
import ReportChannelOption from '../report-create-page/ReportChannelOption';
import Dropdown from 'react-bootstrap/esm/Dropdown';
import DropdownSnapshotLabel from '../../../container/dropdown/dropdown-snapshot-create/DropdownSnapshotLabel';
import TooltipWithTimer from '../../tooltip/TooltipWithTimer';

const DateIndicator = (props) => {
  const activeStyle={
    background: "#BEB4FF",
    color: "#ffffff"
  }
  if (props.onDateBtn == "w1"){
    return (
      <>
        <a className="button option" style={activeStyle} name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "w2"){
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" style={activeStyle} name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m1"){
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" style={activeStyle} name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else if (props.onDateBtn == "m3"){
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" style={activeStyle} name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
  else {
    return (
      <>
        <a className="button option" name="1week" onClick={(e)=>props.handleDateBtn(e)}>1W</a>
        <a className="button option" name="2week" onClick={(e)=>props.handleDateBtn(e)}>2W</a>
        <a className="button option" name="1month" onClick={(e)=>props.handleDateBtn(e)}>1M</a>
        <a className="button option" name="3month" onClick={(e)=>props.handleDateBtn(e)}>3M</a>
      </>
    )
  }
}
const SnapshotCreateOptionBar = (props) => {
  const [tooltipShow, setTooltipShow] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      if(tooltipShow) setTooltipShow(false);
    }, 3000);
    return ()=>clearInterval(timerId);
  }, [tooltipShow])
  
  return (
    <>
      <div className="reportTopBg" style={{height: '100%'}}>
        <div className="settingBox">
          <div className="analysis_indicator">
            <div className="indicator-box">
              날짜 <DateIndicator handleDateBtn={props.handleDateBtn} onDateBtn={props.onDateBtn} />
              &nbsp;&nbsp;<DropdownReportOption img="calendar" >
                <DateRangePickerWithCalendar authed={true} minDate={props.minDate} value={props.dateRange} onChange={props.handleDate} />
              </DropdownReportOption>
            </div>
            <div className="indicator-box">
              <span style={{paddingLeft:"30px"}}>검색어&nbsp;&nbsp;</span>
                {props.edit ?
                  props.defaultQuery.mainQuery && 
                  <Select placeholder="검색어 찾기" isClearable={true} isSearchable={true}
                    defaultValue={props.defaultQuery.mainQuery}
                    options={props.querySelectOption}
                    styles={{
                      container: base => ({
                        ...base,
                        width: "180px",
                        marginTop: "-6px"
                      }),
                      option: base => ({
                        ...base,
                        textAlign: "left"
                      })
                    }}
                    onChange={(e)=>{
                      props.selectMainQuery(e);
                    }}
                  />
                :<Select placeholder="검색어 찾기" isClearable={true} isSearchable={true}
                options={props.querySelectOption}
                styles={{
                  container: base => ({
                    ...base,
                    width: "180px",
                    marginTop: "-6px"
                  }),
                  option: base => ({
                    ...base,
                    textAlign: "left"
                  })
                }}
                onChange={(e)=>{
                  props.selectMainQuery(e);
                }}
              />}&nbsp;
                <DropdownReportOption>
                  {props.edit ? <SubQueryOption edit={true} defaultQuery={props.defaultQuery} subQueryType={props.subQueryType} mainQuery={props.mainQuery} handleSubQueryType={props.handleSubQueryType} selectSubQuery={props.selectSubQuery} multiQuerySelectOption={props.multiQuerySelectOption} />
                  : <SubQueryOption subQueryType={props.subQueryType} mainQuery={props.mainQuery} handleSubQueryType={props.handleSubQueryType} selectSubQuery={props.selectSubQuery} multiQuerySelectOption={props.multiQuerySelectOption} />}
                </DropdownReportOption>
            </div>
            <div className="indicator-box">
              <span style={{paddingLeft:"30px"}}>분석 지표&nbsp;&nbsp;</span>
              {props.edit ? props.defaultReportType &&
                <Select placeholder="리포트 타입 검색" isClearable={true} isSearchable={true} edit={true}
                  defaultValue={props.defaultReportType}
                  isMulti
                  options={props.reportTypeSelectOption}
                  styles={{
                    container: base => ({
                      ...base,
                      width: "290px",
                      marginTop: "-6px"
                    }),
                    option: base => ({
                      ...base,
                      textAlign: "left"
                    })
                  }}
                  onChange={(e)=>{
                    props.selectReportType(e);
                  }}/>
              :<Select placeholder="리포트 타입 검색" isClearable={true} isSearchable={true}
                isMulti
                options={props.reportTypeSelectOption}
                styles={{
                  container: base => ({
                    ...base,
                    width: "290px",
                    marginTop: "-6px"
                  }),
                  option: base => ({
                    ...base,
                    textAlign: "left"
                  })
                }}
                onChange={(e)=>{
                  props.selectReportType(e);
                }}/>
              }
            </div>
          </div>
          <hr style={{height:"1px", border: "0 none", color: "#ccc", backgroundColor: "#e3e3e3", margin:"7.5px"}}/>
          <div className="analysis_indicator">
            <div className="indicator-box">
              <span>[분석 채널]</span>
              {props.channels.map((channel)=>{
                return (
                  <div className="indicator-box-channel">
                    <span style={{paddingRight:"10px"}}>
                      <CheckboxImg labelName={channel.name} className="channel-list-checkbox" checked={channel.checked} id={`channel-checkbox-${channel.id}`} handleCheckBox={props.handleChannels} />
                      {/* {channel.name} */}
                    </span>
                    {channel.subCh.length != 0 ?
                      <DropdownReportOption>
                        <ReportChannelOption checkArray={channel.subCh} handleCheckBox={props.handleChannels} />
                        <Dropdown.ItemText style={{marginBottom: "5px"}} className="optionSettingBtn">
                          <Dropdown.Item style={{width: "auto", marginTop: "10px"}} className="button purple_line">확인</Dropdown.Item>
                        </Dropdown.ItemText>
                      </DropdownReportOption>
                    : undefined}
                  </div>
                )
              })}
            </div>
          </div>
        </div>
        <div className="settingBtn">
          <a className="button purple" onClick={()=>props.handleRunBtn()}>실행</a>&nbsp;
          {props.edit ? 
            <DropdownSnapshotLabel toggle="수정" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>
            :<DropdownSnapshotLabel toggle="저장" handleSaveBtn={(report, label, labelID)=>props.handleSaveBtn(report, label, labelID)} tooltipRef={tooltipTarget} handleTooltip={(bool)=>setTooltipShow(bool)} userLabelData={props.userLabelData}/>}
          <TooltipWithTimer target={tooltipTarget} show={tooltipShow} tooltipDirection="top" tooltipText="스냅샷이 저장되었습니다" />
        </div>
      </div>
    </>
  )
}

export default SnapshotCreateOptionBar;